import { render, staticRenderFns } from "./OrganismFeedSectionContent.vue?vue&type=template&id=fe950f38"
import script from "./OrganismFeedSectionContent.vue?vue&type=script&lang=js"
export * from "./OrganismFeedSectionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports